/**
 * @fileoverview PUT handler for the "/companies/:company_id/oauth_mcp_settings/redirect_uris" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdOauthMcpSettingsRedirectUrisCacheKeys } from "./constants";
import type {
  PutCompaniesCompanyIdOauthMcpSettingsRedirectUrisProps,
  PutCompaniesCompanyIdOauthMcpSettingsRedirectUrisResult,
} from "./types";

export const putCompaniesCompanyIdOauthMcpSettingsRedirectUris = reactQueryMutationAdapter(
  companiesCompanyIdOauthMcpSettingsRedirectUrisCacheKeys,
  (
    props: PutCompaniesCompanyIdOauthMcpSettingsRedirectUrisProps
  ): Promise<PutCompaniesCompanyIdOauthMcpSettingsRedirectUrisResult> => {
    return fetch(
      `/companies/${props.company_id}/oauth_mcp_settings/redirect_uris`,
      "PUT",
      props,
      {},
      { propagateFetchRequestError: false }
    );
  }
);
